<template lang="html">
  <div class="legal-consent-fields flex flex-col gap-3">
    <UFormField name="consentPersonalData">
      <div class="flex items-start gap-2">
        <UCheckbox v-model="consentPersonalData" class="mt-0.5 shrink-0" />
        <span class="text-sm leading-5 text-muted">
          Я даю согласие на
          <LegalDocLink :to="legalPages.personalDataConsent">
            обработку персональных данных
          </LegalDocLink>
        </span>
      </div>
    </UFormField>

    <UFormField :name="termsFieldName">
      <div class="flex items-start gap-2">
        <UCheckbox v-model="acceptTerms" class="mt-0.5 shrink-0" />
        <span class="text-sm leading-5 text-muted">
          <template v-if="mode === 'signup'">
            Я принимаю
            <LegalDocLink :to="legalPages.userAgreement">
              Пользовательское соглашение
            </LegalDocLink>
          </template>
          <template v-else>
            Я принимаю
            <LegalDocLink :to="legalPages.publicOffer">
              Публичную оферту
            </LegalDocLink>
          </template>
        </span>
      </div>
    </UFormField>
  </div>
</template>

<script setup lang="ts">
import LegalDocLink from './LegalDocLink.vue'

import { legalPages } from '#Info/constants/legalPages'

const props = defineProps<{
  mode: 'signup' | 'checkout'
}>()

const consentPersonalData = defineModel<boolean>('consentPersonalData', {
  required: true,
})

const acceptTerms = defineModel<boolean>('acceptTerms', {
  required: true,
})

const termsFieldName = computed(() =>
  props.mode === 'signup' ? 'acceptUserAgreement' : 'acceptPublicOffer',
)
</script>
